import { Injectable } from '@angular/core';

import { IDocumentBase } from 'app/services/api5-service/api.interface';
import { OperatorFunction, pipe, Subject } from 'rxjs';
import { tap } from 'rxjs/operators';

import { HttpResponseHandler } from './model';

/**
 * Http handler service for handling new notifications from BE
 */
@Injectable({
  providedIn: 'root',
})
export class NotifyHandlerService implements HttpResponseHandler {
  /** Doc property $notify subject */
  private readonly docNotifySubject = new Subject<string>();

  /** Doc property $notify stream */
  readonly docNotify$ = this.docNotifySubject.asObservable();

  /**
   * Check response new notify object
   */
  handle(): OperatorFunction<IDocumentBase, IDocumentBase> {
    return pipe(tap(doc => this.docNotifySubject.next(doc.$notify)));
  }

  handleEvent(): OperatorFunction<any, any> {
    // @TODO i.ablov update notifications on file loading
    return pipe();
  }
}
